import React from "react";
import { SubMenuItem } from "./submenu-item";

export const SubMenu = ({ items }) => {
    return (
        <ul data-testid="submenu" className={"submenu"}>
            {items.map((item) => (
                <SubMenuItem item={item} key={item.title} />
            ))}
        </ul>
    );
};
